import { Button } from '@/components/ui/button';
import { DollarSign, TrendingUp, Users, Target } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function AdvertisePage() {
  return (
    <div className="py-12 bg-white">
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-foreground mb-4">Advertise With Us</h1>
          <p className="text-lg text-muted-foreground mb-12">
            Reach thousands of students, professionals, and education enthusiasts actively seeking educational opportunities.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            <div className="border border-border/40 rounded-sm p-6 bg-card">
              <Users size={32} className="text-accent mb-3" />
              <h3 className="text-xl font-playfair font-bold mb-2">Audience Reach</h3>
              <p className="text-muted-foreground">Connect with 50,000+ monthly visitors interested in higher education</p>
            </div>
            <div className="border border-border/40 rounded-sm p-6 bg-card">
              <Target size={32} className="text-accent mb-3" />
              <h3 className="text-xl font-playfair font-bold mb-2">Targeted Marketing</h3>
              <p className="text-muted-foreground">Reach specific demographics: students, professionals, parents</p>
            </div>
            <div className="border border-border/40 rounded-sm p-6 bg-card">
              <TrendingUp size={32} className="text-accent mb-3" />
              <h3 className="text-xl font-playfair font-bold mb-2">High Engagement</h3>
              <p className="text-muted-foreground">Average session duration of 5+ minutes with high content interaction</p>
            </div>
            <div className="border border-border/40 rounded-sm p-6 bg-card">
              <DollarSign size={32} className="text-accent mb-3" />
              <h3 className="text-xl font-playfair font-bold mb-2">Flexible Options</h3>
              <p className="text-muted-foreground">Banner ads, sponsored content, university listings, and more</p>
            </div>
          </div>

          <div className="bg-secondary rounded-sm p-8 mb-12">
            <h2 className="text-2xl md:text-3xl font-playfair font-bold text-foreground mb-4">Advertising Options</h2>
            <ul className="space-y-3 text-muted-foreground mb-6">
              <li className="flex items-start gap-2">
                <span className="text-accent font-bold">•</span>
                <span><strong>Sponsored Articles:</strong> Publish branded content that educates and engages our audience</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accent font-bold">•</span>
                <span><strong>University Listings:</strong> Feature your institution in our university directory</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accent font-bold">•</span>
                <span><strong>Banner Advertisements:</strong> Display ads on high-traffic pages</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accent font-bold">•</span>
                <span><strong>Email Newsletter:</strong> Reach our subscribers directly</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accent font-bold">•</span>
                <span><strong>Course Promotions:</strong> Highlight your educational programs</span>
              </li>
            </ul>
          </div>

          <div className="text-center">
            <h2 className="text-2xl font-playfair font-bold text-foreground mb-4">Ready to Get Started?</h2>
            <p className="text-muted-foreground mb-6">Contact us to discuss custom advertising packages tailored to your needs.</p>
            <Link to="/contact">
              <Button size="lg" className="rounded-sm" data-testid="contact-advertising-btn">
                Contact Sales Team
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}